import React, { useEffect } from "react";
import useConfiguration from "stores/ConfigurationStore/configuration";

const ConfigurationLoader: React.FC = () => {
  const [, actions] = useConfiguration();

  useEffect(() => {
    // actions.getNotification();
    actions.getNapasLimitedAmount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
};

export default ConfigurationLoader;
